// client/src/components/Admin/Dashboard/_shared/DashboardSideNav.js
//
// M06 Fase 7 - Nav lateral sticky con anclas a las 5 secciones del
// dashboard. Se oculta en movil (<992px) y deja el scroll vertical natural.

import React, { useEffect, useState } from "react";
import styles from "./DashboardSideNav.module.scss";

const SECTIONS = [
  { id: "globales", label: "Globales" },
  { id: "k12", label: "K12" },
  { id: "revi", label: "REVI" },
  { id: "simulator", label: "Simulator" },
  { id: "otros", label: "Otros" },
];

export function DashboardSideNav() {
  const [active, setActive] = useState("globales");

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY + 120; // offset para activacion temprana
      let current = "globales";
      SECTIONS.forEach((s) => {
        const el = document.getElementById(s.id);
        if (el && el.offsetTop <= scrollY) {
          current = s.id;
        }
      });
      setActive(current);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const goTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <nav className={styles.sideNav} aria-label="Navegacion del dashboard">
      {SECTIONS.map((s) => (
        <button
          key={s.id}
          type="button"
          className={`${styles.navItem} ${active === s.id ? styles.active : ""}`}
          onClick={() => goTo(s.id)}
        >
          {s.label}
        </button>
      ))}
    </nav>
  );
}
